import { render, staticRenderFns } from "./StoryboardHint.vue?vue&type=template&id=48b001bc&scoped=true&"
import script from "./StoryboardHint.vue?vue&type=script&lang=js&"
export * from "./StoryboardHint.vue?vue&type=script&lang=js&"
import style0 from "./StoryboardHint.vue?vue&type=style&index=0&id=48b001bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b001bc",
  null
  
)

export default component.exports